export default __webpack_public_path__ + "static/media/grafema_armazem-da-alfandega_01.88fbb3f4.jpg";